export const APP_COMING_SOON = !!process.env.REACT_APP_COMING_SOON;
export const APP_COMING_SOON_MESSAGE = process.env.REACT_APP_COMING_SOON_MESSAGE;
export const APP_ENVIRONMENT =
  process.env.REACT_APP_ENVIRONMENT || 'development';
